<template>
  <teleport to="body">
    <transition name="panel">
      <div v-if="show && images && gallery" class="overlay bg-grey">
        <vue-easy-lightbox
          moveDisabled
          :visible="visible"
          :imgs="gallery"
          :index="index"
          @hide="handleHide"
        >
          <!-- eslint-disable-next-line vue/no-unused-vars -->
          <template v-slot:toolbar="{ toolbarMethods }">
            <div></div>
          </template>
        </vue-easy-lightbox>
        <base-dialog
          :show="!!makeBooking"
          title="Make a booking"
          @close="handleBooking"
          theme="grey"
          fixed
        >
          <form-booking theme="light" @close="showSentDialog"></form-booking>
        </base-dialog>
        <base-dialog
          :show="!!sendBooking"
          title="Booking Sent!"
          @close="handleSendBooking"
          fixed
        >
        </base-dialog>
        <the-header theme="grey"></the-header>
        <div class="">
          <div class="px-6 mt-20 mb-5" ref="pageHead">
            <button @click="tryClose">
              <img
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCA4OCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMjkyODkzIDcuMjkyODlDLTAuMDk3NjMxNSA3LjY4MzQyIC0wLjA5NzYzMTUgOC4zMTY1OCAwLjI5Mjg5MyA4LjcwNzExTDYuNjU2ODUgMTUuMDcxMUM3LjA0NzM4IDE1LjQ2MTYgNy42ODA1NCAxNS40NjE2IDguMDcxMDcgMTUuMDcxMUM4LjQ2MTU5IDE0LjY4MDUgOC40NjE1OSAxNC4wNDc0IDguMDcxMDcgMTMuNjU2OUwyLjQxNDIxIDhMOC4wNzEwNyAyLjM0MzE1QzguNDYxNTkgMS45NTI2MiA4LjQ2MTU5IDEuMzE5NDYgOC4wNzEwNyAwLjkyODkzMkM3LjY4MDU0IDAuNTM4NDA4IDcuMDQ3MzggMC41Mzg0MDggNi42NTY4NSAwLjkyODkzMkwwLjI5Mjg5MyA3LjI5Mjg5Wk04OCA3TDEgN1Y5TDg4IDlWN1oiIGZpbGw9IiMyRDI5MjYiLz4KPC9zdmc+Cg=="
                alt=""
              />
            </button>
          </div>
          <div class="gallery-scroll" :style="{ height: galleryHeight }">
            <div class="gallery">
              <div
                v-for="(image, index) in gallery"
                :key="image"
                class="gallery-card"
                @click="showImg(index)"
              >
                <img :src="image" />
              </div>
            </div>
          </div>
        </div>
        <div class="fixed inset-0 pointer-events-none">
          <div
            :class="[
              { 'details-panel-show': filterPanel },
              'details-panel',
              'pointer-events-auto',
            ]"
          >
            <div v-if="$mq === 'sm'" class="text-center">
              <button @click="togglePanel">
                <img
                  :class="[
                    { 'img-arrow-btn-open': filterPanel },
                    'img-arrow-btn',
                  ]"
                  width="25"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDIwMDAgMjAwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Zz48cGF0aCBkPSJtMTc0NCAxNDM2Yy0xNi40IDAtMzIuOC02LjItNDUuMy0xOC43bC02OTguNy02OTguOC02OTguNyA2OTguN2MtMjUgMjUtNjUuNSAyNS05MC41IDBzLTI1LTY1LjUgMC05MC41bDc0NC03NDRjMjUtMjUgNjUuNS0yNSA5MC41IDBsNzQ0IDc0NGMyNSAyNSAyNSA2NS41IDAgOTAuNS0xMi41IDEyLjYtMjguOSAxOC44LTQ1LjMgMTguOHoiIGZpbGw9IiNmZmZmZmYiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIHN0eWxlPSIiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9nPjwvZz48L3N2Zz4="
                />
              </button>
            </div>
            <base-card class="mt-0" theme="grey">
              <div class="grid grid-cols-3 gap-x-4">
                <h2 class="col-span-2">
                  {{ unit.name }}, {{ unit.property_type.name }}
                </h2>
                <div class="text-right">
                  <button v-if="isFavourite" @click="removeFavourite">
                    <img
                      height="20px"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjcwODMgMi44MDIwM0MyMS4xNzYzIDIuMjY5NzQgMjAuNTQ0NiAxLjg0NzUgMTkuODQ5MyAxLjU1OTQxQzE5LjE1NCAxLjI3MTMzIDE4LjQwODggMS4xMjMwNSAxNy42NTYyIDEuMTIzMDVDMTYuOTAzNiAxLjEyMzA1IDE2LjE1ODQgMS4yNzEzMyAxNS40NjMyIDEuNTU5NDFDMTQuNzY3OSAxLjg0NzUgMTQuMTM2MiAyLjI2OTc0IDEzLjYwNDEgMi44MDIwM0wxMi41IDMuOTA2MkwxMS4zOTU4IDIuODAyMDNDMTAuMzIxMSAxLjcyNzM1IDguODYzNTYgMS4xMjM2IDcuMzQzNzMgMS4xMjM2QzUuODIzOTEgMS4xMjM2IDQuMzY2MzMgMS43MjczNSAzLjI5MTY1IDIuODAyMDNDMi4yMTY5NyAzLjg3NjcxIDEuNjEzMjIgNS4zMzQyOSAxLjYxMzIyIDYuODU0MTFDMS42MTMyMiA4LjM3Mzk0IDIuMjE2OTcgOS44MzE1MiAzLjI5MTY1IDEwLjkwNjJMNC4zOTU4MSAxMi4wMTA0TDEyLjUgMjAuMTE0NUwyMC42MDQxIDEyLjAxMDRMMjEuNzA4MyAxMC45MDYyQzIyLjI0MDYgMTAuMzc0MiAyMi42NjI4IDkuNzQyNDYgMjIuOTUwOSA5LjA0NzE5QzIzLjIzOSA4LjM1MTkyIDIzLjM4NzMgNy42MDY3IDIzLjM4NzMgNi44NTQxMUMyMy4zODczIDYuMTAxNTIgMjMuMjM5IDUuMzU2MzEgMjIuOTUwOSA0LjY2MTA0QzIyLjY2MjggMy45NjU3NyAyMi4yNDA2IDMuMzM0MDcgMjEuNzA4MyAyLjgwMjAzVjIuODAyMDNaIiBmaWxsPSIjRkU1MDAwIiBzdHJva2U9IiNGRTUwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
                    />
                  </button>
                  <button v-else @click="addFavourite">
                    <img
                      height="20px"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjcwODMgMi44MDIwM0MyMS4xNzYzIDIuMjY5NzQgMjAuNTQ0NiAxLjg0NzUgMTkuODQ5MyAxLjU1OTQxQzE5LjE1NCAxLjI3MTMzIDE4LjQwODggMS4xMjMwNSAxNy42NTYyIDEuMTIzMDVDMTYuOTAzNiAxLjEyMzA1IDE2LjE1ODQgMS4yNzEzMyAxNS40NjMyIDEuNTU5NDFDMTQuNzY3OSAxLjg0NzUgMTQuMTM2MiAyLjI2OTc0IDEzLjYwNDEgMi44MDIwM0wxMi41IDMuOTA2MkwxMS4zOTU4IDIuODAyMDNDMTAuMzIxMSAxLjcyNzM1IDguODYzNTYgMS4xMjM2IDcuMzQzNzMgMS4xMjM2QzUuODIzOTEgMS4xMjM2IDQuMzY2MzMgMS43MjczNSAzLjI5MTY1IDIuODAyMDNDMi4yMTY5NyAzLjg3NjcxIDEuNjEzMjIgNS4zMzQyOSAxLjYxMzIyIDYuODU0MTFDMS42MTMyMiA4LjM3Mzk0IDIuMjE2OTcgOS44MzE1MiAzLjI5MTY1IDEwLjkwNjJMNC4zOTU4MSAxMi4wMTA0TDEyLjUgMjAuMTE0NUwyMC42MDQxIDEyLjAxMDRMMjEuNzA4MyAxMC45MDYyQzIyLjI0MDYgMTAuMzc0MiAyMi42NjI4IDkuNzQyNDYgMjIuOTUwOSA5LjA0NzE5QzIzLjIzOSA4LjM1MTkyIDIzLjM4NzMgNy42MDY3IDIzLjM4NzMgNi44NTQxMUMyMy4zODczIDYuMTAxNTIgMjMuMjM5IDUuMzU2MzEgMjIuOTUwOSA0LjY2MTA0QzIyLjY2MjggMy45NjU3NyAyMi4yNDA2IDMuMzM0MDcgMjEuNzA4MyAyLjgwMjAzVjIuODAyMDNaIiBzdHJva2U9IiNGRTUwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
                    />
                  </button>
                </div>
              </div>
              <div class="grid grid-cols-3 gap-x-4 mt-5">
                <h2 class="text-white">Cost</h2>
                <div class="text-right col-span-2">£{{ price }}</div>
              </div>
              <div class="break-white w-full"></div>
              <div class="grid grid-cols-3 gap-x-4 mb-3">
                <h2 class="text-white">Floor</h2>
                <div class="text-right col-span-2">{{ floor }}</div>
              </div>
              <div class="grid grid-cols-3 gap-x-4 mb-3">
                <h2 class="text-white">Bedrooms</h2>
                <div class="text-right col-span-2">
                  {{ unit.property_bedroom.name }}
                </div>
              </div>
              <div class="grid grid-cols-3 gap-x-4 mb-3">
                <h2 class="text-white">Bathrooms</h2>
                <div class="text-right col-span-2">
                  {{ unit.property_bathroom.name }}
                </div>
              </div>
              <div class="grid grid-cols-4 gap-x-4">
                <h2 class="text-white">Area</h2>
                <div class="text-right col-span-2">
                  {{ unit.sqm }}m<sup>2</sup>
                </div>
                <div class="text-right col-span-1">
                  {{ unit.sqft }}ft<sup>2</sup>
                </div>
              </div>
              <div class="break-white w-full"></div>
              <div class="grid grid-cols-3 gap-x-4 mb-3">
                <h2 class="text-white">Status</h2>
                <div class="text-right col-span-2">
                  {{ unit.property_status.name }}
                </div>
              </div>
              <div class="grid grid-cols-4 gap-x-4 mb-3">
                <h2 class="text-white">Share</h2>
                <div class="text-right col-span-3">
                  <button
                    v-if="$mq === 'sm'"
                    title="Share via WeChat"
                    class="mr-3"
                  >
                    <img
                      class="img"
                      src="data:image/svg+xml;base64,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"
                    />
                  </button>
                  <button
                    v-if="$mq === 'sm'"
                    title="Share via WhatsApp"
                    class="mr-3"
                  >
                    <img
                      class="img"
                      src="data:image/svg+xml;base64,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"
                    />
                  </button>
                  <button title="Share via Email">
                    <img
                      class="img"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDFMMTAgMTIiIHN0cm9rZT0iIzJEMjkyNiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIxIDFMMTQgMjFMMTAgMTJMMSA4TDIxIDFaIiBzdHJva2U9IiMyRDI5MjYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
                    />
                  </button>
                </div>
              </div>
              <div class="form-control">
                <base-button theme="flat" width="width-100"
                  >360&#176; tour</base-button
                >
              </div>
              <div class="form-control">
                <base-button
                  theme="flat"
                  width="width-100"
                  @click="showFloorplan"
                  >Floorplan</base-button
                >
              </div>
              <div class="form-control-mb-0">
                <base-button
                  theme="flat"
                  width="width-100"
                  @click="handleBooking"
                  >Make a booking</base-button
                >
              </div>
            </base-card>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import FormBooking from "../forms/FormBooking.vue";
import PhotoSwipe from "../photoswipe/index.js";

export default {
  components: {
    VueEasyLightbox,
    FormBooking,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    unit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterPanel: false,
      visible: false,
      index: 0, // default: 0
      makeBooking: false,
      sendBooking: false,
      galleryHeight: 0,
    };
  },
  computed: {
    images() {
      return this.$store.getters["categories/images"];
    },
    gallery() {
      const images = this.$store.getters["categories/images"];
      const gallery = [];
      Object.keys(images).forEach(function(prop) {
        if (images[prop].category === "Unit-Images") {
          gallery.push(images[prop].large);
        }
      });
      return gallery;
    },
    price() {
      return formatMoney(this.unit.price);
    },
    floor() {
      let floorStr = "";
      this.unit.property_floors.forEach(function(floor) {
        floorStr += floor.name + ",";
      });
      return (floorStr = floorStr.slice(0, -1));
    },
    isFavourite() {
      const favourites = this.$store.getters["units/favourites"];
      return favourites.some((favourite) => favourite[this.unit.id]);
    },
  },
  emits: ["close"],
  created() {
    this.loadCategories();
  },
  updated() {
    this.setGalleryHeight();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.setGalleryHeight);
      this.setGalleryHeight();
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setGalleryHeight);
  },
  methods: {
    async loadCategories(refresh = false) {
      this.isLoading = true;
      try {
        await this.$store.dispatch("categories/loadCategories", {
          forceRefresh: refresh,
        });
      } catch (error) {
        this.error = error.message || "Something went wrong!";
      }
      this.isLoading = false;
    },
    tryClose() {
      this.$emit("close");
    },
    togglePanel() {
      this.filterPanel = !this.filterPanel;
    },
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    handleBooking() {
      this.makeBooking = !this.makeBooking;
    },
    showSentDialog() {
      this.handleBooking();
      this.sendBooking = true;
    },
    handleSendBooking() {
      this.sendBooking = false;
    },
    addFavourite() {
      const unit = {};
      unit[this.unit.id] = this.unit;
      this.$store.dispatch("units/addFavourite", unit);
    },
    removeFavourite() {
      this.$store.dispatch("units/removeFavourite", this.unit.id);
    },
    showFloorplan() {
      PhotoSwipe.preview(
        this.images[this.unit.property_type.name].large,
        {},
        this
      );
    },
    setGalleryHeight() {
      if (this.$refs.pageHead) {
        this.galleryHeight =
          window.innerHeight - this.$refs.pageHead.clientHeight - 200 + "px";
      }
    },
  },
};

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    console.log(e);
  }
}
</script>

<style scoped>
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 80;
  left: 0;
  top: 0;
  overflow: hidden;
}

.panel-enter-from,
.panel-leave-to {
  opacity: 0;
  /* transform: scale(0.8); */
}

.panel-enter-active {
  transition: all 0.3s ease-out;
}

.panel-leave-active {
  transition: all 0.3s ease-in;
}

.panel-enter-to,
.panel-leave-from {
  opacity: 1;
  /* transform: scale(1); */
}

.gallery-scroll {
  overflow: auto;
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  margin-left: 1.5rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .gallery-scroll {
    margin-left: 5rem;
  }
}

.gallery {
  height: 100%; /*dyanmic*/
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.gallery-card {
  display: inline-block;
  height: 100%;
  margin-right: 0.5rem;
}

.gallery-card img {
  height: 100%;
  width: auto;
  max-width: unset;
}

.details-panel {
  position: absolute;
  width: 100%;
  top: calc(100% - 95px);
  left: unset;
  bottom: unset;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  z-index: 85;
  transition: all 1s;
  margin: 0 !important;
}

.details-panel-show {
  transform: translateY(-80%);
}

@media (min-width: 768px) {
  .details-panel {
    left: 1.5rem;
    bottom: 1.5rem;
    width: 315px;
    top: unset;
    padding-left: 0;
    padding-right: 0;
  }
}

.form-control {
  margin: 0.5rem 0;
}

.form-control-mb-0 {
  margin: 0.5rem 0 0;
}

.mt-0 {
  margin-top: 0 !important;
}

.img-arrow-btn {
  transition: transform 1s ease-in-out;
}

.img-arrow-btn-open {
  transform: rotate(180deg);
}

.break-white {
  border-bottom: 2px solid #fff;
  margin: 1rem 0;
}

.img {
  height: 20px;
}
</style>
